
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cara-pembayaran",
      function () {
        return require("private-next-pages/cara-pembayaran/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cara-pembayaran"])
      });
    }
  